import { Injectable } from "@angular/core";

import { PageResultDto } from "../dto";

import {
  CreateNotificationDto,
  FindNotificationDto,
  NotificationDto,
  UpdateNotificationDto,
} from "@api/dto/notification.dto";
import { HttpService } from "./http.service";

const NOTIFICATION_URL = "/admin/v1/notification-campaigns";

@Injectable()
export class AdminNotificationService {
  constructor(private httpService: HttpService) { }

  async find(findNotificationDto: FindNotificationDto) {
    return await this.httpService.get<PageResultDto<NotificationDto>>(
      NOTIFICATION_URL,
      findNotificationDto
    );
  }

  async create(createNotificationDto: CreateNotificationDto) {
    return await this.httpService.post<NotificationDto>(
      NOTIFICATION_URL,
      createNotificationDto
    );
  }

  async findOne(id: string) {
    return await this.httpService.get<NotificationDto>(
      `${NOTIFICATION_URL}/${id}`
    );
  }

  async update(id: string, updateNotificationDto: UpdateNotificationDto) {
    return await this.httpService.put<Boolean>(
      `${NOTIFICATION_URL}/${id}`,
      updateNotificationDto
    );
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`${NOTIFICATION_URL}/${id}`);
  }

  async enabledNotification(id: string, status: boolean) {
    return await this.httpService.patch<Boolean>(
      `${NOTIFICATION_URL}/${id}/status`,
      { status }
    );
  }
}
